
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, ExternalLink, AlertCircle } from 'lucide-react';
import { createJournalistOnboarding, getJournalistDashboard } from '@/services/stripeService';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

const JournalistConnect = () => {
  const [loading, setLoading] = useState(false);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [connected, setConnected] = useState(false);

  const handleConnect = async () => {
    setLoading(true);
    try {
      const result = await createJournalistOnboarding();
      if (result?.url) {
        window.location.href = result.url;
      }
    } catch (error) {
      console.error('Error connecting to Stripe:', error);
    }
    setLoading(false);
  };

  const handleViewDashboard = async () => {
    setDashboardLoading(true);
    try {
      const result = await getJournalistDashboard();
      if (result?.url) {
        window.open(result.url, '_blank');
      }
    } catch (error) {
      console.error('Error opening dashboard:', error);
    }
    setDashboardLoading(false);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Monetize Your Content</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {!connected ? (
          <>
            <Alert className="bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>Connect to Stripe</AlertTitle>
              <AlertDescription>
                Connect your Stripe account to receive payments directly from your readers.
              </AlertDescription>
            </Alert>
            <div className="space-y-4">
              <h3 className="font-medium">Why Connect?</h3>
              <ul className="space-y-2">
                <li className="flex items-start text-sm">
                  <span className="mr-2">•</span>
                  <span>Receive direct payments from subscribers</span>
                </li>
                <li className="flex items-start text-sm">
                  <span className="mr-2">•</span>
                  <span>Set custom pricing for your content</span>
                </li>
                <li className="flex items-start text-sm">
                  <span className="mr-2">•</span>
                  <span>Access detailed payment analytics</span>
                </li>
              </ul>
            </div>
            <Button 
              onClick={handleConnect}
              disabled={loading}
              className="w-full sm:w-auto"
            >
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Connect Stripe Account
            </Button>
          </>
        ) : (
          <>
            <Alert className="bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>Stripe Connected</AlertTitle>
              <AlertDescription>
                Your Stripe account is connected and ready to receive payments.
              </AlertDescription>
            </Alert>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 border rounded-lg">
                <h3 className="text-sm font-medium text-muted-foreground mb-1">Total Earnings</h3>
                <p className="font-medium text-2xl">$0.00</p>
              </div>
              <div className="p-4 border rounded-lg">
                <h3 className="text-sm font-medium text-muted-foreground mb-1">Subscribers</h3>
                <p className="font-medium text-2xl">0</p>
              </div>
            </div>
            <Button 
              onClick={handleViewDashboard}
              disabled={dashboardLoading}
              className="w-full sm:w-auto"
            >
              {dashboardLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              View Stripe Dashboard
              <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default JournalistConnect;
